export default __webpack_public_path__ + "static/media/JAS0180.34I-43388_-25957_15.c9f3bc29.jpg";